export default "__VITE_ASSET__DLHkmUlb__"